import { render, staticRenderFns } from "./ActivationBriefPersonalInfoView.vue?vue&type=template&id=c2106596&scoped=true&"
import script from "./ActivationBriefPersonalInfoView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefPersonalInfoView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationBriefPersonalInfoView.vue?vue&type=style&index=0&id=c2106596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2106596",
  null
  
)

export default component.exports